import en from "./en.json";
import it from "./it.json";

const brand_text = { en, it };

export default brand_text;
